import type React from "react"
import { useAppDispatch, useAppSelector } from "@/app/hooks"
import {
  setLoginSheetOpen,
  selectIsLoginSheetOpen,
} from "@/features/auth/authSlice"
import { FaGoogle, FaComment } from "react-icons/fa"
import { ActionSheet } from "@/components/ui"
import "@/styles/LoginActionSheet.css"

const LoginActionSheet: React.FC = () => {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector(selectIsLoginSheetOpen)
  const apiBaseUrl = import.meta.env.VITE_API_URL

  const openPopup = (url: string) => {
    const width = 600
    const height = 700
    const left = window.screen.width / 2 - width / 2
    const top = window.screen.height / 2 - height / 2
    window.open(
      url,
      "oauth-login",
      `width=${width},height=${height},top=${top},left=${left}`,
    )
  }

  const handleGoogleLogin = () => {
    openPopup(`${apiBaseUrl}/oauth2/authorization/google`)
  }

  const handleKakaoLogin = () => {
    openPopup(`${apiBaseUrl}/oauth2/authorization/kakao`)
  }

  const handleClose = () => {
    dispatch(setLoginSheetOpen(false))
  }

  const loginItems = [
    {
      label: "Google 계정으로 로그인",
      onClick: handleGoogleLogin,
      icon: <FaGoogle />,
      className: "login-button google"
    },
    {
      label: "카카오 계정으로 로그인",
      onClick: handleKakaoLogin,
      icon: <FaComment />,
      className: "login-button kakao"
    }
  ]

  return (
    <ActionSheet
      isOpen={isOpen}
      onClose={handleClose}
      title="로그인"
      description="SNS 계정으로 간편하게 로그인하세요."
      items={loginItems}
    />
  )
}

export default LoginActionSheet
